import { FC } from 'react';
import Link from 'next/link';
import SectionTitle from '../section-title/SectionTitle';
import { ISimilarAuthors } from '@/interfaces/similarAuthors';
import { getAuthorFullName, getBookNoun } from '@/helpers/helpers';
import styles from './SimilarAuthorsList.module.scss';

interface ISimilarAuthorsList {
  similarAuthors: ISimilarAuthors;
}
const SimilarAuthorsList: FC<ISimilarAuthorsList> = ({ similarAuthors }) => {
  return (
    <>
      <SectionTitle name="Похожие авторы:" />
      <div className={styles.similarAuthorsScroll}>
        <div className={styles.similarAuthorsScroll__wrap} data-scrollbar="styles">
          <ul className={styles.similarAuthors}>
            {similarAuthors.map((author) => (
              <li key={author.author_id} className={styles.similarAuthors__item}>
                <span className={styles.similarAuthors__img}></span>
                <span className={styles.similarAuthors__info}>
                  <Link prefetch={false} href={`/avtor/${author.alias}/`} className={styles.similarAuthors__name}>
                    {getAuthorFullName(author.first_name, author.second_name || '', author.last_name)}
                  </Link>
                  <p className={styles.similarAuthors__books}>
                    {author.authors_books_count} {getBookNoun(author.authors_books_count)}
                  </p>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};
export default SimilarAuthorsList;
